export const STATUS_BAD_REQUEST = 400;
export const STATUS_UNAUTHORIZED = 401;
export const STATUS_FORBIDDEN = 403;
export const STATUS_NOT_FOUND = 404;
export const STATUS_METHOD_NOT_ALLOWED = 405;
export const STATUS_REQUEST_TIMEOUT = 408;
export const STATUS_SERVER_ERROR = 500;
export const STATUS_NOT_IMPLEMENTED = 501;
export const STATUS_SERVICE_UNAVAILABLE = 503;
export const CODE_UNDEFINED = 100000;
export const CODE_INTERNAL_ERROR = 100001;
export const CODE_INVALID_METHOD = 100002;
export const CODE_VERSION_UPDATING = 100003;
export const CODE_INVALID_TOKEN = 110001;
export const CODE_INVALID_COMPANY_ACCOUNT = 110002;
export const CODE_INVALID_ARGUMENT = 110004;
export const CODE_INVALID_PERMISSION = 110005;
export const CODE_INVALID_SITE = 110006;
export const CODE_INVALID_OPERATION = 110007;
export const CODE_DATA_NOT_FOUND = 110010;
export const CODE_GROUPING_NOT_ALLOWED = 110020;
